import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { siteConfig } from "../data/site";
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <Logo />
          <p>We design fans that breathe with you.</p>
        </div>
        <div>
          <b>Menu</b>
          <Link to="/">Home</Link>
          <Link to="/shop">Shop</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div>
          <b>Legal</b>
          <Link to="/legal/privacy-policy">Privacy Policy</Link>
          <Link to="/legal/cookie-policy">Cookie Policy</Link>
          <Link to="/legal/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/legal/delivery-and-return">Delivery and Return</Link>
        </div>
        <div>
          <b>Contact</b>
          <a href={`tel:${siteConfig.phone.replace(/\s/g, "")}`}>
            {siteConfig.phone}
          </a>
          <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
        </div>
        <div>
          <b>Service</b>
          <Link to="/portal/tickets">Book a service</Link>
          <Link to="/login">Customer login</Link>
          <Link to="/login" state={{ role: "technician" }}>
            Technician login
          </Link>
        </div>
        <div>
          <b>Newsletter</b>
          <form onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Email Address"
              aria-label="Email Address"
            />
            <button aria-label="Subscribe">
              <ArrowUpRight size={16} />
            </button>
          </form>
        </div>
      </div>
      <div className="footer-word">KIZAK</div>
      <div className="copyright">
        © 2026 - KIZAK · Powered By STUDIO HORNTAIL
      </div>
    </footer>
  );
}